<template>
  <!-- Main content -->
    <!-- Info boxes -->
    <div class="row">
      <div class="col-xs-12 p-10 text-center">
        <div class="form-group input-group pull-left">
          <select v-model="storeIds" class="form-control h-38">
            <option value="all">全部</option>
            <option v-for="store in storeBrief" :value="store.value">{{store.label}}</option>
          </select>
        </div>
        <div class="form-group input-group pull-right">
          <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
          <span class="hidden-xs">&nbsp; ~ &nbsp;</span>
          <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
          <span>
            <button class="btn btn-success submit-btn btn-search" type="button"
                    id="brand-chart-search" @click="getChart" style="top: -2px;">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10">
        <div class="box">
          <div class="box-header with-border p-0">
            <div class="col-xs-12">
              <div class="box-header">
                <h3 class="box-title">當日訂單數量與杯數比較</h3><br><br>
                <div class="box-body p-0">
                  <div class="col-xs-12">
                    <canvas id="today-amount-compare"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10">
        <div class="box">
          <div class="box-header with-border p-0">
            <div class="col-xs-12">
              <div class="box-header">
                <div class="col-xs-12">
                  <h3 class="box-title">當日訂單數量與總額比較</h3><br><br>
                  <div class="box-body p-0">
                    <div class="col-xs-12">
                      <canvas id="today-money-compare"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10">
        <div class="box">
          <div class="box-header with-border p-0">
            <div class="col-xs-12">
              <div class="box-header">
                <h3 class="box-title">當日訂單平均金額</h3><br><br>
                <div class="box-body p-0">
                  <div class="col-xs-12">
                    <canvas id="today-money-average"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10">
        <div class="box">
          <div class="box-header with-border p-0">
            <div class="col-xs-12">
              <div class="box-header">
                <h3 class="box-title">當日會員數量</h3><br><br>
                <div class="box-body p-0">
                  <div class="col-xs-12">
                    <canvas id="shopper-brief"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
var amountCompareChart, moneyCompareChart, moneyAverageChart, amountAverageChart, shopperBriefChart
import moment from 'moment'
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      brandIds: '',
      changeStore: false,
      storeStatusList: {},
      content: {
        bindingStoreList: []
      },
      oldUrl: '',
      storeIds: 'all',
      storeBrief: [],
      brandBrief: [],
      // transactions
      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },
      // member brief
      memberBriefLabels: [],
      memberBrief: {
        total_day: [],
        total_accum: []
      },
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        },
        storeTime: {
          time: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      storeLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ]
    }
  },
  methods: {
    getChart () {
      var storeSelect = parseInt(this.storeIds, 10)
      if (storeSelect) this.getTransactions('store', this.storeIds)
      else this.getTransactions('brand', this.brandIds)
    },
    checkLimit (val) {
      if (this.content.bindingStoreList.length > 10) {
        this.content.bindingStoreList.shift()
      }
      if (this.content.bindingStoreList.length) {
        this.getStoresTransactions()
      } else {
        this.storeStatusList = {}
      }
    },
    clickSearch () {
      if (this.content.bindingStoreList.length) this.getStoresTransactions()
    },
    getStoresTransactions () {
      const list = this.content.bindingStoreList
      const day = moment(this.menuTime.storeTime.time, 'YYYY-MM-DD').format('YYYYMMDD')
      var ids = ''
      for (var i = 0; i < list.length; i++) {
        ids = ids + list[i].value + ','
      }
      ids = ids.slice(0, -1)
      var self = this
      var data = {
        start_time: day,
        end_time: day,
        ids: ids
      }
      var url = ''
      url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + data.ids
      if (this.oldUrl !== url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            let resDay = moment(day, 'YYYYMMDD').format('YYYY-MM-DD')
            if (response.data.statistics[resDay]) self.storeStatusList = response.data.statistics[resDay].store_info
            self.oldUrl = url
          }
        })
      }
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          self.brandIds = brandIds
          self.getTransactions('brand', brandIds)
          self.getStoreBrief(brandIds)
        }
      })
    },
    getTransactions (type, id) {
      this.transactionLabels = []
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      else if (type === 'store') url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var tList = response.data.statistics
          var info
          for (var i in tList) {
            if (type === 'brand') {
              info = 'brand_info'
            } else if (type === 'store') {
              info = 'store_info'
            }
            self.transactionLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
            self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum)
            self.transactions.order_count_day.push(tList[i][info][id].order_count_day)
            self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal)
            self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group)
            self.transactions.money_accum.push(tList[i][info][id].money_accum)
            self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean)
            self.transactions.money_day.push(tList[i][info][id].money_day)
            self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal)
            self.transactions.money_day_group.push(tList[i][info][id].money_day_group)
            self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean)
            self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum)
            self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean)
            self.transactions.item_count_day.push(tList[i][info][id].item_count_day)
            self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal)
            self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group)
          }
          self.getShoppers(type, id)
          self.showTransactionsChart(type)
        }
      })
    },
    getShoppers (type, id) {
      this.memberBriefLabels = []
      this.memberBrief = {
        total_day: [],
        total_accum: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      else if (type === 'store') url = '/statistic/storeShopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList
          if (type === 'brand') bList = response.data.brand_shopper_status_list
          else if (type === 'store') bList = response.data.store_shopper_status_list
          for (var i in bList) {
            self.memberBriefLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
            self.memberBrief.total_day.push(bList[i].total_day)
            self.memberBrief.total_accum.push(bList[i].total_accum)
          }
          self.showShopperChart(type)
        }
      })
    },
    showTransactionsChart (type) {
      this.$nextTick(() => {
        var datas = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交杯數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }]
        var datas2 = [{
          label: '當日訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day,
          yAxisID: 'y-axis-1'
        }]
        var datas3 = [{
          label: '當日平均金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day_mean
        }]
        /*
        var datas4 = [{
          label: '當日訂單數量',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-1'
        }]
        */
        if (typeof amountCompareChart !== 'undefined') {
          amountCompareChart.destroy()
        }
        if (typeof moneyCompareChart !== 'undefined') {
          moneyCompareChart.destroy()
        }
        if (typeof moneyAverageChart !== 'undefined') {
          moneyAverageChart.destroy()
        }
        if (typeof amountAverageChart !== 'undefined') {
          amountAverageChart.destroy()
        }
        var ctx = document.getElementById('today-amount-compare').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        var ctx2 = document.getElementById('today-money-compare').getContext('2d')
        var config2 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        var ctx3 = document.getElementById('today-money-average').getContext('2d')
        var config3 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        /*
        var ctx4 = document.getElementById('today-amount-average').getContext('2d')
        var config4 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas4
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        */
        amountCompareChart = new Chart(ctx, config) // eslint-disable-line no-new
        moneyCompareChart = new Chart(ctx2, config2) // eslint-disable-line no-new
        moneyAverageChart = new Chart(ctx3, config3) // eslint-disable-line no-new
        // amountAverageChart = new Chart(ctx4, config4) // eslint-disable-line no-new
      })
    },
    showShopperChart (type) {
      this.$nextTick(() => {
        var datas = [{
          label: '當日會員數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.memberBrief.total_day,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日累積會員數量',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.memberBrief.total_accum,
          yAxisID: 'y-axis-1'
        }]
        if (typeof shopperBriefChart !== 'undefined') {
          shopperBriefChart.destroy()
        }
        var ctx = document.getElementById('shopper-brief').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.memberBriefLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        shopperBriefChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    var date = new Date()
    this.menuTime.start.time = moment(date).add(-30, 'days').format('YYYY-MM-DD')
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'content.bindingStoreList' () {
      this.checkLimit()
    },
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    },
    storeIds () {
      this.getChart()
    }
  }
}
</script>
<style lang="sass" scope>
#brand-chart-search
  top: -2px
  border-radius: 0px 3px 3px 0px !important
@media screen and (max-width: 767px)
  .box-title
    text-align: center
    width: 100%
</style>



// WEBPACK FOOTER //
// BrandChart.vue?3573b29a